"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _intl = require("@kyruus/intl");
var _styles = _interopRequireDefault(require("./styles"));
var _messages = _interopRequireDefault(require("../../lib/messages"));
const PhoneNumberLink = _ref => {
  let {
    phone,
    intl,
    onClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styles.default, {
    href: `tel:${phone}`,
    title: intl.formatMessage(_messages.default.phoneNumberLinkTitle, {
      phone_number: phone
    }),
    onClick: onClick,
    "data-testid": "PhoneNumberLink"
  }, phone);
};
PhoneNumberLink.propTypes = {
  phone: _propTypes.default.string.isRequired,
  /**
   * Injected by `injectIntl HOC`
   */
  intl: _propTypes.default.shape({
    formatMessage: _propTypes.default.func.isRequired
  }).isRequired,
  onClick: _propTypes.default.func
};
var _default = exports.default = (0, _intl.injectIntl)(PhoneNumberLink);
PhoneNumberLink.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PhoneNumberLink",
  "props": {
    "phone": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "intl": {
      "description": "Injected by `injectIntl HOC`",
      "type": {
        "name": "shape",
        "value": {
          "formatMessage": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": true
    },
    "onClick": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};